<template>
    <div class="problem-container">
        <feedback-header :title="title" :is-goback="false" @feedback-back="backFn" />
        <div v-show="!isCommitView" class="problem-select">
            <div class="problem-title">请选择有问题的类型</div>
            <ul v-show="!isShowSub" class="problem-main">
                <li v-for="(item, index) in TypesOfFeedback" :key="index" class="main-items" @click.prevent="selectProblemType(item, index)">
                    <img :src="item.imgUrl" alt="意见反馈图标" />
                    <p class="item-title">{{ item.title }}</p>
                    <p class="item-remark">{{ item.remarks }}</p>
                    <icon name="right"></icon>
                </li>
            </ul>
            <ul v-show="isShowSub" class="problem-sub">
                <li v-for="(item, index) in TypesOfFeedback[typeIndex].content" :key="index" class="sub-items" @click="fillInProblem(item)">
                    {{ item }}
                </li>
            </ul>
        </div>
        <div v-show="isCommitView" class="problem-commit">
            <div class="commit-head">
                <p class="commit-title">请描述您遇到的具体问题</p>
                <p class="commit-desc">我们期待为您带来最好的服务</p>
                <p class="customer" @click="onlineConsult"><img src="@/assets/images/feedback/CS.png" class="cs-img" /><span>在线客服</span></p>
            </div>
            <div class="commit-body">
                <div class="input-content">
                    <textarea v-model="feedbackWords" class="input-text" :placeholder="placeholder" maxlength="200" @input="inputting"></textarea>
                    <span class="left-words">{{ inputtedWords }}/200</span>
                </div>
                <feedback-upload ref="feedbackUpload" :title="title" />
                <div class="client-info">
                    <input v-model="name" type="text" placeholder="姓名(选填)" maxlength="20" />
                    <input v-model="mobile" type="text" placeholder="联系方式(选填)" maxlength="20" />
                </div>
                <div class="link-service">若有问题需要咨询或解决，请联系<span @click="onlineConsult">在线客服</span></div>
            </div>
            <div class="submit">
                <button type="button" class="btn-submit" :class="activeBtn ? 'btn-active' : ''" @click.prevent="commit">提交</button>
            </div>
        </div>
    </div>
</template>

<script>
import FeedbackHeader from './feedback-header'
import { getCookie } from '../../util/util'
import FeedbackUpload from './feedback-upload'
import getOnlineService from '@/mixins/onlineService/index'

export default {
    components: {
        FeedbackHeader,
        FeedbackUpload
    },
    data() {
        return {
            isLogin: getCookie('loginUser'),
            title: this._ll('遇到问题'),
            csUrl: '', // 在线客服地址
            isShowSub: false,
            typeIndex: 0,
            TypesOfFeedback: [
                {
                    title: '寄快递',
                    type: '0',
                    imgUrl: require('@/assets/images/feedback/parcel.png'),
                    remarks: '信息填写、地址薄、下单异常等',
                    content: ['收/寄件人信息填写', '快递员上门下单', '自寄下单', '完善快件信息（托寄物、付款方式、保价、增值服务、备注）', '其他']
                },
                {
                    title: '查快递',
                    type: '1',
                    imgUrl: require('@/assets/images/feedback/search.png'),
                    remarks: '更改派送、路由信息、自寄码等',
                    content: [
                        '查件列表（运单号、运单状态）',
                        '输入运单/扫码查快递',
                        '服务评价',
                        '投诉',
                        '更改派送',
                        '删除运单',
                        '路由显示（地图、文字）',
                        '运单详情',
                        '自寄码',
                        '其他'
                    ]
                },
                {
                    title: '其他功能',
                    type: '2',
                    imgUrl: require('@/assets/images/feedback/other.png'),
                    remarks: '会员福利、偏好设置、服务查询等',
                    content: [
                        '运费时效/服务范围/收寄标准查询',
                        '服务网点查询',
                        '偏好设置（派送偏好、消息推送）',
                        '会员福利（积分、会员权益等）',
                        '我的钱包',
                        '投诉理赔',
                        '会员退出/注销',
                        '其他'
                    ]
                }
            ],
            placeholder: '',
            feedbackWords: '',
            inputtedWords: 0,
            isCommitView: false,
            name: '',
            mobile: '',
            activeBtn: false,
            typeOne: '问题', // 反馈类型
            typeTwo: '', // 问题大类
            typeThree: '' // 问题小类
        }
    },
    watch: {
        inputtedWords: function () {
            this.inputtedWords !== 0 ? (this.activeBtn = true) : (this.activeBtn = false)
        }
    },
    methods: {
        async onlineConsult() {
            this.csUrl = await getOnlineService()
            window.open(this.csUrl, '_blank')
        },
        backFn() {
            if (this.isShowSub && !this.isCommitView) {
                this.isShowSub = false
            } else if (this.isCommitView) {
                this.isCommitView = false
            } else {
                this.$router.push({ name: 'feedback' })
            }
        },
        // 选择问题类型
        selectProblemType(item, index) {
            this.isShowSub = true
            this.typeIndex = index
            this.typeTwo = item.title
        },
        // 进入填写问题
        fillInProblem(item) {
            this.isCommitView = true
            this.typeThree = item
            this.placeholder = `请详细描述${item}的问题，我们会努力改进的哦 (必填)`
        },
        inputting() {
            this.inputtedWords = this.feedbackWords.length
        },
        commit() {
            if (!this.activeBtn) {
                return
            } // 未激活不可点击
            if (this.isLogin) {
                // 提交前要登录
                // 调用子组件commit方法
                this.$refs.feedbackUpload.postOrUpload({
                    typeOne: this.typeOne, //  一类名称
                    typeTwo: this.typeTwo, //  二类名称
                    typeThree: '', //  三类名称
                    remark: this.feedbackWords, //  功能报障原因
                    name: this.name, //  姓名
                    mobile: this.mobile, //  联系方式
                    channelCode: 'MOBILE.OWF'
                })
            } else {
                this.$router.push({ name: 'login' })
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.problem-container {
    padding: 0 0.2rem 0.4rem;
    background: $bg-color;
    height: 100%;
    .problem-select {
        .problem-title {
            font-size: 0.4rem;
            margin-top: 0.2rem;
            margin-left: 0.4rem;
        }
        .problem-main {
            width: 96%;
            margin: 0 auto;
            .main-items {
                margin-top: 0.3rem;
                background: $white;
                position: relative;
                padding: 0.7rem 0 0.7rem 1.2rem;
                border-radius: 0.1rem;
                img {
                    position: absolute;
                    top: 50%;
                    left: 0.3rem;
                    margin-top: -0.3rem;
                    width: 0.6rem;
                }
                .item-title {
                    color: $black;
                    font-weight: bold;
                    font-size: 0.34rem;
                }
                .item-remark {
                    color: $gray;
                    font-size: 0.26rem;
                    margin-top: 0.12rem;
                }
                .icon-right {
                    width: 0.3rem;
                    position: absolute;
                    top: 50%;
                    margin-top: -0.15rem;
                    right: 0.4rem;
                    color: $gray-light;
                }
            }
        }
        .problem-sub {
            margin-top: 0.4rem;
            max-height: 11rem;
            overflow-y: auto;
            .sub-items {
                margin-bottom: 0.2rem;
                background: $white;
                border-radius: 0.1rem;
                padding: 0.3rem;
                font-size: 0.26rem;
            }
        }
    }
    .problem-commit {
        font-size: 0.26rem;
        .commit-head {
            width: 96%;
            height: 1.8rem;
            box-shadow: 0.02rem 0.1rem 0.4rem $gray-light;
            border-radius: 0.2rem;
            margin: 0 auto;
            position: relative;
            padding-left: 0.4rem;
            background: $white;
            .commit-title {
                font-size: 0.4rem;
                padding-top: 0.4rem;
            }
            .commit-desc {
                font-size: 0.26rem;
                color: $gray;
            }
            .customer {
                position: absolute;
                top: 0.4rem;
                right: 0.2rem;
                width: 1.56rem;
                height: 0.44rem;
                background: $bg-color;
                border-radius: 0.1rem;
                font-size: 0.16rem;
                .cs-img {
                    width: 0.3rem;
                    margin: 0.1rem;
                }
                span {
                    position: absolute;
                    top: 0.08rem;
                    font-size: 0.22rem;
                }
            }
        }
        .commit-body {
            padding: 0 0.5rem;
            background: $white;
            margin-top: -1rem;
            padding-top: 1rem;
            padding-bottom: 1rem;
            .input-content {
                position: relative;
                .left-words {
                    position: absolute;
                    right: 0.4rem;
                    bottom: 0.2rem;
                    color: $gray-light;
                }
                .input-text {
                    width: 98%;
                    min-height: 2.4rem;
                    margin-top: 0.3rem;
                    padding: 0.2rem 0.24rem;
                    border: 1px solid $gray-lighter;
                    background: $bg-gray;
                    &:empty {
                        &:before {
                            content: attr(placeholder);
                            color: $gray-light;
                        }
                    }
                    &:focus {
                        &:before {
                            content: none;
                        }
                    }
                }
            }
            .client-info {
                input {
                    width: 46%;
                    margin-right: 0.2rem;
                }
            }
            .link-service {
                font-size: 0.26rem;
                color: $gray;
                margin-top: 0.2rem;
                span {
                    color: $link-blue;
                }
            }
        }
        .submit {
            text-align: right;
            margin-top: -0.5rem;
            .btn-submit {
                width: 2.46rem;
                height: 0.9rem;
                margin-right: 0.5rem;
                color: $bg-color;
                background: $gray;
                border-radius: 0.5rem;
                border: none;
                &.btn-active {
                    background: $red;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/feedback/feedback-problem.vue